import { Divider, Flex, Modal, Space, theme } from 'antd'
import { FolderOpenOutlined, LinkOutlined, UserOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { DateFormat } from '../../utils/constants.ts'
import { UserLabelsList } from '../common/UserLabelsList.tsx'
import type { Document } from '../../backend/types/document.ts'
import type { Report } from '../../backend/types/report.ts'
import { useGetMoneyFlow } from '../../api/case/document.ts'

interface ReportSummaryModalProps {
    isModalOpen: boolean
    toggleModal: () => void
    reportDocument: Document<Report>
}

// const initialBalance = {
//     inFlow: 0,
//     outFlow: 0,
//     holdingBalance: 0,
// }

export const ReportSummaryModal = ({ reportDocument, isModalOpen, toggleModal }: ReportSummaryModalProps) => {
    const { token } = theme.useToken()

    const { data: moneyFlow } = useGetMoneyFlow(reportDocument.moneyflowId)
    const reportEntity = reportDocument.entities.find((entity) => entity.ID === reportDocument.entityId)

    // const { data: balancesMap = {}, isPending: balancesPending } = useGetReportEntityBalance(
    //     reportDocument._id,
    //     reportEntity!.ID
    // )

    // const totalBalance = useMemo(() => Object.values(balancesMap || {}).reduce((accum, balanceData) => {
    //     Object.values(balanceData).forEach((currencyData) => {
    //         accum.inFlow += currencyData.inFlowUSD
    //         accum.outFlow += currencyData.outFlowUSD
    //         accum.holdingBalance += currencyData.holdingBalanceUSD
    //     })
    //     return accum
    // }, initialBalance), [balancesMap])

    //const mintOrBurn = reportEntity?.Type === EntityType.burn || reportEntity?.Type === EntityType.mint

    return (
        <Modal
            onCancel={toggleModal}
            mask={false}
            footer={null}
            open={isModalOpen}
            title={reportDocument.name}
            closable
            width={660}
        >
            <Flex vertical gap={token.marginSM}>
                <Divider />
                <Flex vertical={true} gap={token.marginXS} style={{ color: token.colorTextSecondary }}>
                    <Space>
                        <LinkOutlined />
                        Originated from: {moneyFlow?.name ?? 'Deleted money flow'}
                    </Space>
                    <Space>
                        <FolderOpenOutlined />
                        Created on: {dayjs(reportDocument.createdAt).format(DateFormat.REPORT_SUMMARY)}
                    </Space>
                    <Space>
                        <UserOutlined />
                        Created by: {reportDocument.creator.name}
                    </Space>
                </Flex>
                <UserLabelsList recordId={reportDocument._id} />
                <Divider />
                <Flex wrap='wrap' align='center' gap={token.marginLG} style={{ color: token.colorTextSecondary }}>
                    <Space direction='vertical'>
                        <span style={{ fontSize: token.fontSizeSM }}>Entity name</span>
                        {reportEntity?.Name}
                    </Space>
                    <Divider type='vertical' style={{ height: 32 }} />
                    <Space direction='vertical'>
                        <span style={{ fontSize: token.fontSizeSM }}>Total addresses</span>
                        {reportEntity?.AddressesLabeled.length}
                    </Space>
                </Flex>
                <Divider />
                {/*<Flex wrap="wrap" align="center" gap={token.marginLG} style={{ color: token.colorTextSecondary }}>
                <Space direction="vertical">
                    <span style={{ fontSize: token.fontSizeSM }}>Inbound</span>
                    <Skeleton
                        loading={balancesPending}
                        active={balancesPending}
                        title={false}
                        paragraph={{ rows: 1, width: 60 }}
                    >
                        {formatter.format(totalBalance.inFlow)}
                    </Skeleton>
                </Space>
                <Divider type="vertical" style={{ height: 32 }} />
                <Space direction="vertical">
                    <span style={{ fontSize: token.fontSizeSM }}>Outbound</span>
                    <Skeleton
                        loading={balancesPending}
                        active={balancesPending}
                        title={false}
                        paragraph={{ rows: 1, width: 60 }}
                    >
                        {formatter.format(totalBalance.outFlow)}
                    </Skeleton>
                </Space>
                {mintOrBurn ? null : <><Divider type="vertical" style={{ height: 32 }} />
                    <Space direction="vertical">
                        <span style={{ fontSize: token.fontSizeSM }}>Holdings</span>

                        <Skeleton
                            loading={balancesPending}
                            active={balancesPending}
                            title={false}
                            paragraph={{ rows: 1, width: 60 }}
                        >
                            {formatter.format(totalBalance.holdingBalance > 0 ? totalBalance.holdingBalance : 0)}
                        </Skeleton>
                    </Space></> }
            </Flex>*/}
            </Flex>
        </Modal>
    )
}
